import { IAuthServiceV2 } from "@volkswagen-onehub/authservice";
import { NoSubscriptionSettingsFoundError } from "./errors/NoSubscriptionSettingsFoundError";

export interface IVcfSubscriptionsSettingsTopic {
    readonly id: string,
    readonly eMail?: boolean,
    readonly push?: boolean,
}

export interface IVcfSubscriptionsSettingsResponse {
    readonly data?: {
        readonly topics?: IVcfSubscriptionsSettingsTopic[];
    };
}

export class VcfSubscriptionsSettingsClient {
    private readonly headers: HeadersInit = {
        'User-Id': '__userId__',
    }

    private readonly resourceHostId: string;

    private getGdcType = (isWcar: boolean) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;

    constructor(private readonly authService: IAuthServiceV2, private readonly stage: string) {
        this.resourceHostId = `myvw-vcf-${stage}`
    }

    // https://cardata.apps.emea.vwapps.io/documentation#tag/Notifications/operation/getSubscriptionsSettings
    public async getSubscriptionsSettings(vin: string, isWcar: boolean): Promise<IVcfSubscriptionsSettingsResponse> {
        const response = await this.authService.get(this.resourceHostId,
            `vehicles/${vin}/subscriptions/settings?gdc=${this.getGdcType(isWcar)}`, this.headers);

        if (response.status === 404) {
            throw new NoSubscriptionSettingsFoundError();
        }

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as IVcfSubscriptionsSettingsResponse;
    }

    // https://cardata.apps.emea.vwapps.io/documentation#tag/Notifications/operation/putSubscriptionsSettings
    public async saveSubscriptionsSettings(vin: string, isWcar: boolean, settings: IVcfSubscriptionsSettingsTopic[]): Promise<void> {
        const payload = {topics: settings};

        const response = await this.authService.put(this.resourceHostId,
            `vehicles/${vin}/subscriptions/settings?gdc=${this.getGdcType(isWcar)}`, JSON.stringify(payload), this.headers);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

    }
}